import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import React, { Component } from 'react';
import Message from '../../../utils/Message/Message';
import { all_information, loadingShow } from '../../../App';
import {
  AddEventType,
  DeleteEventType,
  EditEventType,
  getEventType,
} from '../../../services/EventType/EventTypeServices';

interface IState {
  EventTypeData: any;
}
interface IProps {}
export class EventType extends Component<IProps, IState> {
  private gridEventTypeObj: any;
  public validationRule: Object = { required: true };
  constructor(prop: IProps) {
    super(prop);
    this.state = {
      EventTypeData: [],
    };
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  toolbarClick(args: any) {
    if (args.item.id === 'refresh') {
      this.getEventType();
    }
    if (this.gridEventTypeObj && args.item.id === 'gridEventType_excelexport') {
      this.gridEventTypeObj.excelExport();
    }
  }

  getEventType() {
    getEventType().then((res) => {
      this.setState({ EventTypeData: res.data });
    });
  }
  componentDidMount() {
    this.getEventType();
  }
  SavePointAdd(data: any) {
    const obj = {
      organizationId: all_information.company_id?.toString(),
      createdBy: all_information.user_id,
      typeCode: data.typeCode,
      typeDescription: data.typeDescription,
      typeAlias: data.typeAlias,
    };
    AddEventType(obj)
      .then((res: any) => {
        Message.success('Success');
        loadingShow(false);
        this.getEventType();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  SavePointEdit(data: any) {
    const obj = {
      organizationId: all_information.company_id?.toString(),
      createdBy: all_information.user_id,
      typeCode: data.typeCode,
      typeDescription: data.typeDescription,
      typeAlias: data.typeAlias,
      id: data.id,
    };
    EditEventType(obj)
      .then((res: any) => {
        Message.success('Success');
        loadingShow(false);
        this.getEventType();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  deletePoint(obje: any) {
    const obj = JSON.stringify({
      id: obje[0].id,
    });
    DeleteEventType(obj)
      .then((res: any) => {
        Message.success('Success');
        loadingShow(false);
        this.getEventType();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  actionBeginEventType(args: any) {
    if (args.action === 'add') {
      this.SavePointAdd(args.data);
    } else if (args.action === 'edit') {
      this.SavePointEdit(args.data);
    } else if (args.requestType === 'delete') {
      this.deletePoint(args.data);
    }
  }
  render() {
    return (
      <div>
        <GridComponent
          id='gridEventType'
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.EventTypeData}
          height='calc(-220px + 100vh)'
          ref={(g) => (this.gridEventTypeObj = g)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          allowExcelExport={true}
          showColumnChooser
          toolbarClick={this.toolbarClick.bind(this)}
          actionBegin={this.actionBeginEventType.bind(this)}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='typeCode'
              headerText='Event Type Code'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='typeDescription'
              headerText='Event Type Description'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='typeAlias'
              headerText='Event Type Alias'
              textAlign='Left'
              validationRules={this.validationRule}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Page,
              ColumnChooser,
              ExcelExport,
              ColumnMenu,
              Resize,
              Group,
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}

export default EventType;
